import { render, staticRenderFns } from "./HowItWorksSection.PD-10913.vue?vue&type=template&id=f0d77cfc&scoped=true"
import script from "./HowItWorksSection.PD-10913.vue?vue&type=script&lang=js"
export * from "./HowItWorksSection.PD-10913.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksSection.PD-10913.vue?vue&type=style&index=0&id=f0d77cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d77cfc",
  null
  
)

/* custom blocks */
import block0 from "./HowItWorksSection.PD-10913.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports